<template>
  <span class="render-money">
    {{ format() }}
  </span>
</template>

<script>
import { formatCurrencyFraction2 } from '../../utils/index';
export default {
  props: {
    value: {
      type: Number,
      default: 0,
      required: true,
    },
    maxFractionDigits: {
      type: Number,
      default: 2,
      required: false,
    },
  },
  methods: {
    format() {
      return formatCurrencyFraction2(this.value, this.maxFractionDigits);
    },
  },
};
</script>

<style lang="scss" scoped>
.render-money {
  text-align: right;
}
</style>
